/* Produktkarte — "In den Warenkorb" ohne Seitenwechsel.

   Der Knopf steht in einem echten <form action="/cart/add">. Ohne
   JavaScript sendet es ab und die Kundin landet im Warenkorb; das ist
   der Rueckfall und bleibt funktionsfaehig. Mit JavaScript wird
   stattdessen /cart/add.js benutzt und die Schublade aktualisiert.

   Ein einzelner Zuhoerer am Dokument deckt alle Karten ab — auch die,
   die spaeter nachgeladen werden (Suche, Empfehlungen, Filter). */
(() => {
  const RESET_MS = 1800;

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.product-card__form');
    if (!form) return;

    const button = form.querySelector('[data-card-add]');
    const label = form.querySelector('[data-card-add-label]');
    if (!button || !label) return;

    const id = form.querySelector('input[name="id"]');
    if (!id || !id.value) return;

    e.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;

    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    const original = label.textContent;
    const done = button.dataset.addedLabel;
    /* Ob die Schublade aufgeht, entscheidet die Theme-Einstellung. */
    const openDrawer = button.dataset.openDrawer !== 'false';

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id.value), quantity: 1 }] }),
      });

      if (!res.ok) throw new Error('add failed');

      document.dispatchEvent(
        new CustomEvent('cart:refresh', { detail: { open: openDrawer } })
      );

      if (done) {
        label.textContent = done;
        setTimeout(() => { label.textContent = original; }, RESET_MS);
      }
    } catch (err) {
      /* Kein stiller Fehlschlag: ohne Rueckmeldung klickt man weiter
         und glaubt, es sei etwas im Warenkorb. */
      form.submit();
      return;
    } finally {
      button.removeAttribute('aria-busy');
      button.disabled = false;
    }
  });
})();
